import * as angular from 'angular';
import {ExportBillingOrdersTablePayloadModel} from "../models/export-billing-orders-table-payload.model";

export class BillingOrdersRequests {

  /* @ngInject */
  constructor(private $billingOrders, private BillingOrdersAPI) {
  }

  getBillingOrder(id) {
    const api = this.BillingOrdersAPI.actions.getBillingOrder;
    return this.$$call(api, {}, {}, {billingOrderId: id});
  }

  getPrice(billingOrderId) {
    const api = this.BillingOrdersAPI.actions.getPrice;
    return this.$$call(api, {}, {}, {billingOrderId: billingOrderId});
  }

  updatePrice(billingOrderId, priceOffer) {
    const api = this.BillingOrdersAPI.actions.updatePrice;
    return this.$$call(api, {}, priceOffer, {billingOrderId: billingOrderId});
  }

  createInvoice(invoice) {
    const api = this.BillingOrdersAPI.actions.createInvoice;
    return this.$$call(api, {}, invoice, {});
  }

  deleteInvoice(billingOrderId) {
    const api = this.BillingOrdersAPI.actions.deleteInvoice;
    return this.$$call(api, {}, {}, {billingOrderId: billingOrderId});
  }

  getInvoice(billingOrderId) {
    const api = this.BillingOrdersAPI.actions.getInvoice;
    return this.$$call(api, {responseType: 'arraybuffer'}, {}, {billingOrderId: billingOrderId})
  }

  syncPrice(billingOrderId) {
    const api = this.BillingOrdersAPI.actions.syncPrice;
    return this.$$call(api, {}, {}, {billingOrderId: billingOrderId});
  }

  exportCSV(payload: ExportBillingOrdersTablePayloadModel) {
    const api = this.BillingOrdersAPI.actions.exportCSV;
    return this.$$call(api, {}, payload, {});
  }

  manualPaid(billingOrderId) {
    const api = this.BillingOrdersAPI.actions.manualPaid;
    return this.$$call(api, {}, {}, {billingOrderId: billingOrderId});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$billingOrders().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingOrdersRequests', BillingOrdersRequests);
